export enum Theme {
  light = 'light',
  dark = 'dark'
}
